var hasAuth = (request) => {
    if(localStorage.getItem("token") && localStorage.getItem("tokenExpiration") > Date.now()/1000){
        return request();
    }else{
        localStorage.clear();
        window.location.reload();
    }
};

export default {hasAuth};